import { defineMessages } from 'react-intl';

export default defineMessages({
    viewDownload: {
        id: 'tdic.billing.billing-summary.billing-documents-page.View/Download',
        defaultMessage: 'View/Download'
    },
    downloadErrorMessage: {
        id: 'tdic.billing.billing-summary.billing-documents-page.Apologies: we are unable to access your billing documents at this time. Please try again later.',
        defaultMessage: 'Apologies: we are unable to access your billing documents at this time. Please try again later.'
    },
});
